import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-vino-coins',
  templateUrl: './vino-coins.component.html',
  styleUrls: ['./vino-coins.component.css']
})
export class VinoCoinsComponent implements OnInit {
  @Input() earnVcCount: any;
  @Input() earnVcDescription: any;
  @Output() onClosePopup = new EventEmitter();
  winVcStatement = "";

  constructor( 
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.winVcStatement = this.translate.instant("notifications.win_vinos").replace("$1", this.earnVcCount);
  }

  closePopup(): void {
    this.onClosePopup.emit();
  }
}
